import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Input,
  Select,
  useToast,
  Tooltip,
} from '@chakra-ui/react';
import moment from 'moment';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { EditIcon, AddIcon, ViewIcon } from '@chakra-ui/icons';
import { Link as Chakralink } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import AddModal from './addModal';
import EditModal from './editModal';
import TicketApi from 'api/ticket';
import { usePermissions } from 'contexts/PermissionContext';
import { Modules } from 'config/constant';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PageError from 'components/nopermission/PageError';
import { isValidUUID } from 'utils/fetchUtils';
import DashboardReportApi from 'api/dashboardreport';

function truncateText(text, maxLength) {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
  return text.split('\n');
}

export default function TableData(props) {
  const withId = props.withId;
  console.log('here is withId Value', withId);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [listTotal, setListTotal] = useState(2);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [priorityFilter, setPriorityFilter] = useState('');
  const { getPermissionsForModule } = usePermissions();
  const [permissions, setPermissions] = useState(null);
  const [fetchListError, setFetchListError] = useState(false);
  const customerId = useMemo(() => IdFromUrl(window.location.href), []);
  function IdFromUrl(url) {
    const parts = url.split('/');
    const id = parts[parts.length - 1];
    return id;
  }

  const debounceTimeout = useRef(null); // Reference to track debounce timeout
  const handleInputChange = (value) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      handleSearch(value); // Call the actual search handler after debounce time
    }, 800); // Debounce delay (e.g., 800ms)
  };
  const handleSearch = async (search) => {
    setSearchTerm(search);
  };

  useEffect(() => {
    const permissions = getPermissionsForModule([Modules.CustomerTicket]);
    setPermissions(permissions);
    DashboardReportApi.Notifications();
  }, []);

  const fetchList = async () => {
    if (withId && !isValidUUID(customerId)) {
      setFetchListError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await TicketApi.List(
        withId
          ? {
            searchTerm,
            statusFilter,
            priorityFilter,
            currentPage,
            itemsPerPage,
            customerId,
          }
          : {
            searchTerm,
            statusFilter,
            priorityFilter,
            currentPage,
            itemsPerPage,
          }
      );
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setFetchListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setFetchListError(true);
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      setFetchListError(true);
      console.log(err);
    }
  };

  useEffect(() => {
    if (permissions?.read) {
      fetchList();
    }
  }, [
    currentPage,
    searchTerm,
    statusFilter,
    priorityFilter,
    customerId,
    permissions,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, statusFilter, priorityFilter]);

  if (!permissions?.read) {
    return <NoPermissionsMessage module={Modules.CustomerTicket} />;
  }
  return fetchListError ? (
    <PageError />
  ) : (
    <Flex
      height='100%'
      mt={withId ? '0px' : '8rem'}
      direction='column'>
      <Flex
        direction={{ sm: 'column', md: 'row' }}
        px={withId ? 0 : 5}
        pt={withId ? 0 : 5}
        mb='10px'
        width='100%'
        gap={10}>
        <Flex
          direction={{ sm: 'column', lg: 'row' }}
          gap={10}>
          <Input
            variant='auth'
            minWidth='300px'
            type='text'
            placeholder='Search by Subject or Phone No.'
            onChange={(e) => handleInputChange(e.target.value)} // Use debounced handler
          />

          <Select
            minW='150px'
            id='status-filter'
            value={statusFilter}
            variant='auth'
            onChange={(e) => setStatusFilter(e.target.value)}>
            <option value=''>Select Status</option>
            <option value='OPEN'>Open</option>
            <option value='INPROGRESS'>In Progress</option>
            <option value='CLOSED'>Closed</option>
            <option value='RESOLVED'>Resolved</option>
          </Select>

          <Select
            minW='160px'
            id='priority-filter'
            value={priorityFilter}
            onChange={(e) => setPriorityFilter(e.target.value)}
            variant='auth'>
            <option value=''>Select Priority</option>
            <option value='LOW'>Low</option>
            <option value='NORMAL'>Normal</option>
            <option value='HIGH'>High</option>
          </Select>
        </Flex>

        <Flex ml='auto'>
          <Tooltip
            label={
              !permissions?.create
                ? 'You do not have permission to add'
                : undefined
            }
            placement='top'
            shouldWrapChildren>
            <AddModal
              Icon={<AddIcon />}
              head={'Create New Ticket'}
              // customerPhoneNumber={phoneNumber}
              func={fetchList}
              disabled={!permissions.create}
            />
          </Tooltip>
        </Flex>
      </Flex>

      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Request No.
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Subject
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Priority
                </Flex>
              </Th>

              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Status
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Created At
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Last Updated
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Message
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Actions
                </Flex>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.code}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'
                        noOfLines={1}>
                        {truncateText(obj.subject, 50)}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.priority}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Text
                      size='sm'
                      fontWeight='700'
                      color={textColor}>
                      {obj.status}
                    </Text>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        size='sm'
                        fontWeight='700'
                        color={textColor}>
                        {moment(obj.created_at).format('DD MMM YY, HH:mm')}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Text
                      size='sm'
                      fontWeight='700'
                      color={textColor}>
                      {moment(obj.updated_at).format('DD MMM YY, HH:mm')}
                    </Text>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Tooltip label={obj.message}>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'
                          noOfLines={1}
                          isTruncated>
                          {truncateText(obj.message, 50)}
                        </Text>
                      </Tooltip>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex justify='space-around'>
                      <Tooltip
                        label={
                          !permissions?.update
                            ? 'You do not have permission to edit'
                            : undefined
                        }
                        placement='top'
                        shouldWrapChildren>
                        <EditModal
                          Icon={<EditIcon />}
                          head={'Edit Ticket'}
                          initialData={obj}
                          func={fetchList}
                          disabled={!permissions.update}
                        />
                      </Tooltip>
                      <Chakralink>
                        <Link
                          to={{
                            pathname: `/admin/ticketDetails/${obj.id}`,
                            state: { ticketId: obj.id },
                          }}>
                          <Button>
                            <ViewIcon />
                          </Button>
                        </Link>
                      </Chakralink>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
